import React from 'react';

import TickIcon from '../assets/v2/TickIcon';
import { COLORS } from '../theme';

const Icon = (
  <span className="MuiCheckbox-icon">
    <TickIcon />
  </span>
);

export default {
  defaultProps: {
    disableRipple: true,
    icon: Icon,
    checkedIcon: Icon,
    indeterminateIcon: Icon,
  },
  styleOverrides: {
    root: {
      // icon

      '.MuiCheckbox-icon': {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 20,
        height: 20,
        backgroundColor: COLORS.white,
        border: `1px solid ${COLORS.black30}`,
        borderRadius: 4,

        svg: {
          visibility: 'hidden',
          fontSize: 18,

          path: {
            fill: COLORS.white,
            stroke: COLORS.white,
            strokeWidth: 0.5,
          },
        },
      },

      '&.Mui-checked .MuiCheckbox-icon': {
        backgroundColor: COLORS.green,
        borderColor: 'transparent',

        svg: {
          visibility: 'visible',
        },
      },

      '&.MuiCheckbox-indeterminate .MuiCheckbox-icon': {
        backgroundColor: COLORS.green,
        borderColor: 'transparent',

        '&::after': {
          position: 'absolute',
          top: '50%',
          left: '50%',
          width: 12,
          height: 2,
          background: COLORS.white,
          content: '""',
          transform: 'translate(-50%, -50%)',
        },
      },

      '&.Mui-disabled .MuiCheckbox-icon': {
        borderColor: COLORS.black10,
      },

      '&.Mui-disabled.Mui-checked .MuiCheckbox-icon': {
        backgroundColor: COLORS.black30,
        borderColor: 'transparent',
      },

      '&.Mui-focusVisible .MuiCheckbox-icon': {
        boxShadow: `0 0 0 1px ${COLORS.white}, 0 0 0 3px ${COLORS.green}`,
      },

      // label

      '& + .MuiFormControlLabel-label': {
        color: COLORS.black60,
      },

      '&.Mui-checked + .MuiFormControlLabel-label': {
        color: COLORS.kinetikBlack,
      },

      '&.Mui-disabled + .MuiFormControlLabel-label': {
        color: COLORS.black30,
      },
    },
  },
};
